<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="mt-10"><span class="home-title-page">Visão Geral</span></div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card :loading="dataset.loading" class="home-card-details">
          <v-card-text>
            <v-row>
              <v-col>
                <span class="text-h6 mr-4 home-card-details-title"> Filtros </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-select :disabled="dataset.loading" v-on:change="normalizeRangeByType" dense
                  :items="dataset.periodTypes" label="Período" v-model="dataset.filterSelected" item-value="type"
                  item-text="label" outlined :rules="[$rules.required]" required hide-details="auto">
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-dialog ref="dialog" v-model="dataset.datePickerStartDialog" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="$moment(dataset.rangeDate.startDate).format('DD/MM/YYYY')"
                      :disabled="dataset.filterSelected != 9" readonly dense label="Data início" required v-bind="attrs"
                      v-on="dataset.filterSelected == 9 ? on : null" outlined hide-details>
                    </v-text-field>
                  </template>
                  <v-date-picker locale="pt-br" v-model="dataset.rangeDate.startDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dataset.datePickerStartDialog = false">
                      Cancelar
                    </v-btn>
                    <v-btn text color="primary" @click="
                      $refs.dialog.save(dataset.rangeDate.startDate)
                    dataset.datePickerStartDialog = false
                      ">
                      Salvar
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="12" md="4">
                <v-dialog ref="dialog" v-model="dataset.datePickerEndDialog" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="$moment(dataset.rangeDate.endDate).format('DD/MM/YYYY')"
                      :disabled="dataset.filterSelected != 9" readonly dense label="Data fim" required v-bind="attrs"
                      v-on="dataset.filterSelected == 9 ? on : null" outlined hide-details>
                    </v-text-field>
                  </template>
                  <v-date-picker locale="pt-br" v-model="dataset.rangeDate.endDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dataset.datePickerEndDialog = false">
                      Cancelar
                    </v-btn>
                    <v-btn text color="primary" @click="
                      $refs.dialog.save(dataset.rangeDate.endDate)
                    dataset.datePickerEndDialog = false
                      ">
                      Salvar
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <div class="button-group">
                  <v-btn :loading="dataset.loading" type="button" elevation="0" color="primary"
                    @click="loadData()">Filtrar</v-btn>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col v-for="(item, index) in dataset.itemsCount" :key="index" :cols="12"
                :md="12 / Math.min(dataset.itemsCount.length, 4)">
                <v-card class="home-card-details">
                  <v-card-title>
                    <span class="home-card-details-title">
                      {{ item.title }}
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                        </template>
                        <span>{{ item.description }}</span>
                      </v-tooltip>
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <span class="text-h5 font-weight-bold">{{ item.count }}</span>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mt-6">
              <v-col>
                <v-card class="home-card-details">
                  <v-card-title>
                    <span class="home-card-details-title">
                      Distribuição por <strong class="text-uppercase">status</strong>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                        </template>
                        <span>Visão geral dos pedidos por tipo e status</span>
                      </v-tooltip>
                    </span>
                  </v-card-title>

                  <v-card-text>
                    <v-row>
                      <!-- Habilitação / Divergência - STATUS-->
                      <v-col cols="12" md="4">
                        <v-card outlined>
                          <v-card-title class="subtitle-1 font-weight-bold">
                            Habilitação / Divergência
                          </v-card-title>
                          
                          <apexchart v-if="dataset.summaryChart && dataset.summaryChart.habDiv && dataset.summaryChart.habDiv.series.length" type="donut" height="260"
                            :options="dataset.summaryChart.habDiv.options" :series="dataset.summaryChart.habDiv.series" />
                        </v-card>
                      </v-col>

                      <!-- Revisão de Crédito - STATUS -->
                      <v-col cols="12" md="4">
                        <v-card outlined>
                          <v-card-title class="subtitle-1 font-weight-bold">
                            Revisão de crédito
                          </v-card-title>

                          <apexchart v-if="dataset.summaryChart && dataset.summaryChart.creditReview && dataset.summaryChart.creditReview.series.length" type="donut" height="260"
                            :options="dataset.summaryChart.creditReview.options" :series="dataset.summaryChart.creditReview.series" />
                        </v-card>
                      </v-col>

                      <!-- Adesões ao Plano - STATUS -->
                      <v-col cols="12" md="4">
                        <v-card outlined>
                          <v-card-title class="subtitle-1 font-weight-bold">
                            Adesão ao plano
                          </v-card-title>

                          <apexchart v-if="dataset.summaryChart && dataset.summaryChart.planAdhesion && dataset.summaryChart.planAdhesion.series.length" type="donut" height="260"
                            :options="dataset.summaryChart.planAdhesion.options" :series="dataset.summaryChart.planAdhesion.series" />
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mt-6">
              <v-col>
                <v-card class="home-card-details">
                  <v-card-title>
                    <span class="home-card-details-title">
                      Distribuição por <strong class="text-uppercase">classe</strong>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                        </template>
                        <span>Visão geral dos pedidos por tipo e classe</span>
                      </v-tooltip>
                    </span>
                  </v-card-title>

                  <v-card-text>
                    <v-row>
                      <!-- Habilitação / Divergência - CLASSE -->
                      <v-col cols="12" md="4">
                        <v-card outlined>
                          <v-card-title class="subtitle-1 font-weight-bold">
                            Habilitação / Divergência - Negócios
                          </v-card-title>
                          
                          <apexchart v-if="dataset.typesChart && dataset.typesChart.habDiv && dataset.typesChart.habDiv.series.length" type="donut" height="260"
                            :options="dataset.typesChart.habDiv.options" :series="dataset.typesChart.habDiv.series" />
                        </v-card>
                      </v-col>

                      <!-- Revisão de Crédito - CLASSE -->
                      <v-col cols="12" md="4">
                        <v-card outlined>
                          <v-card-title class="subtitle-1 font-weight-bold">
                            Revisão de crédito - Negócios
                          </v-card-title>

                          <apexchart v-if="dataset.typesChart && dataset.typesChart.creditReview && dataset.typesChart.creditReview.series.length" type="donut" height="260"
                            :options="dataset.typesChart.creditReview.options" :series="dataset.typesChart.creditReview.series" />
                        </v-card>
                      </v-col>

                      <!-- Adesões ao Plano - CLASSE -->
                      <v-col cols="12" md="4">
                        <v-card outlined>
                          <v-card-title class="subtitle-1 font-weight-bold">
                            Adesão ao plano
                          </v-card-title>

                          <apexchart v-if="dataset.typesChart && dataset.typesChart.planAdhesion && dataset.typesChart.planAdhesion.series.length" type="donut" height="260"
                            :options="dataset.typesChart.planAdhesion.options" :series="dataset.typesChart.planAdhesion.series" />
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-row v-for="(item, index) in dataset.charts" :key="item.title + '-' + index">
                  <v-col>
                    <v-card class="home-card-details">
                      <v-card-title>
                        <v-row>
                          <v-col>
                            <span class="home-card-details-title">
                              {{ item.title }}
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                                </template>
                                <span>{{ item.description }}</span>
                              </v-tooltip>
                              <v-select class="mt-2" v-if="item.type == 'list'" dense
                                :items="item.settings.listRefFields" label="Campo referência"
                                @change="value => onSelectChange(index, value)" v-model="item.settings.refField" item-value="value"
                                item-text="label" outlined hide-details="auto">
                              </v-select>
                            </span>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col v-if="item.type == 'list'" align="right">
                            <v-tooltip bottom>
                              <template #activator="{ on }">
                                <v-btn color="blue-grey" class="ma-2 white--text" small @click="exportListToCSV(item)">
                                  Exportar
                                  <v-icon right dark> mdi-export-variant </v-icon>
                                </v-btn>
                              </template>
                              <span>Exportar CSV do relatório <strong>{{ item.title }}</strong></span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-card-text>
                        <apexchart v-if="item.type == 'bar'" height="300" type="bar"
                          :options="item.settings.chartOptions" :series="item.settings.series"></apexchart>
                        <v-data-table v-if="item.type == 'list'" :headers="item.settings.headers"
                          :items="item.settings.items" :items-per-page="5" class="elevation-1"
                          :footer-props="{ 'items-per-page-text': 'Itens por página' }" 
                          no-data-text="Nenhum registro foi encontrado">
                          <template v-slot:item.actions="{ item }">
                            <v-btn dense elevation="0">
                              <span class="caption font-weight-bold">Ver</span>
                              <v-icon small>mdi-arrow-right</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-row>
                  <v-col>
                    <v-card class="home-card-details" :loading="dataset.loading">
                      <v-card-title>
                        <v-row>
                          <v-col>
                            <span class="home-card-details-title">
                              Movimentações
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                                </template>
                                <span>Visão geral das movimentações dos administradores</span>
                              </v-tooltip>

                              <v-text-field v-model="searchQuery" label="Buscar movimentações" outlined dense
                                @input="onSearch"></v-text-field>
                            </span>
                          </v-col>
                          <v-spacer></v-spacer>
                        </v-row>
                      </v-card-title>

                      <v-card-text>
                        <v-data-table :headers="headers" :items="dataList.data" :server-items-length="dataList.count"
                          :items-per-page="dataList.options.itemsPerPage" @update:page="pageChanged"
                          @update:items-per-page="onItemsPerPageChange" :loading="dataList.loading" class="elevation-1"
                          :footer-props="dataList.footerOptions" no-data-text="Nenhum registro foi encontrado"
                          loading-text="Carregando dados...">
                          <template v-slot:item="props">
                            <tr>
                              <td class="text-left">{{ props.item.description }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import 'moment/locale/pt-br'

import VueApexCharts from 'vue-apexcharts'
import eventStatus from "@/common/data/event-status.data"

import debounce from 'lodash/debounce'

import axios from 'axios'

export default {
  components: {
    apexchart: VueApexCharts
  },

  data: () => ({
    user: null,
    dataList: {
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 5,
        totalPages: null
      },
      count: 0,
      data: [],
      footerOptions: {
        itemsPerPageText: 'Itens por página:',
        itemsPerPageOptions: [5, 10, 20, 30, 50],
        pageText: '{0}-{1} de {2}',
        prevPage: 'Página anterior',
        nextPage: 'Próxima página'
      }
    },
    searchQuery: '',
    headers: [{ text: 'Descrição', align: 'start', key: 'description' }],
    dataset: {
      eventStatus: eventStatus,
      statusColors: {
        0: '#FB8C00', // laranja
        1: '#43A047', // verde
        2: '#E53935',  // vermelho
        3: 'indigo darken-1', // azul
        4:  "#7E55AB", // roxo
        5:  "#29B6F6", // azul claro
        6:  "#9E9D24"
      },
      typesColors: {
        1: '#9C27B0', // purple
        3: '#009688', // teal
        4: '#03A9F4', // light blue
      },
      typesCountList: [
        { id: 1, name: "Trabalhista" },
        { id: 3, name: "Quirografários" },
        { id: 4, name: "ME/EPP" },
      ],
      loading: false,
      itemsCount: [],
      typesCount: [],
      periodTypes: [
        {
          label: 'Hoje',
          type: 1
        },
        {
          label: 'Ontem',
          type: 2
        },
        {
          label: '7 dias',
          type: 3
        },
        {
          label: '15 dias',
          type: 4
        },
        {
          label: '30 dias',
          type: 5
        },
        {
          label: 'Esse mês',
          type: 6
        },
        {
          label: 'Mês passado',
          type: 7
        },
        {
          label: 'Últimos 3 meses',
          type: 8
        },
        {
          label: 'Personalizado',
          type: 9
        }
      ],
      filterSelected: 3,
      rangeDate: { startDate: null, endDate: null },
      charts: [],
      summaryChart: {
        habDiv: {
          series: [],
          options: {}
        },
        creditReview: {
          series: [],
          options: {}
        },
        planAdhesion: {
          series: [],
          options: {}
        }
      },
      typesChart: {
        habDiv: {
          series: [],
          options: {}
        },
        creditReview: {
          series: [],
          options: {}
        },
        planAdhesion: {
          series: [],
          options: {}
        }
      }
    }
  }),

  mounted: function () {
    this.user = this.$root.user
  },

  created() {
    this.loadData()
  },

  methods: {
    async loadData() {
      this.normalizeRangeByType()

      this.dataset.itemsCount = []
      this.dataset.charts = []

      this.dataset.loading = true

      try {
        await this.loadUsersCount()
        await this.loadEventsCount()
        await this.loadReviewsEventsCount()
        await this.loadAdherencesCount()
        await this.loadTypeCountList()
        await this.loadUsersGroup()
        await this.loadEventsGroup()
        await this.loadResponsibleEventGroup()
        await this.loadResponsibleEventLog()
        await this.loadAdminLogs()
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 })
      } finally {
        this.dataset.loading = false
      }
    },

    async onSearch() {
      this.loadAdminLogs()
    },

    loadAdminLogs: debounce(async function () {
      let search = this.searchQuery ? { content: this.searchQuery } : {}

      this.dataList.loading = true

      const limit = this.dataList.options.itemsPerPage
      const start = (this.dataList.options.page - 1) * limit

      try {
        const result = await axios.get('/api/admin/listlogs', {
          params: {
            page: this.dataList.options.page,
            limit: limit,
            search: JSON.stringify(search)
          }
        })

        this.dataList.data = result.data.content.data
        this.dataList.count = result.data.content.paging.total
        this.dataList.options.totalPages = Math.ceil(this.dataList.count / limit)
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataList.loading = false
      }
    }, 500),

    onItemsPerPageChange(newLimit) {
      this.dataList.options.itemsPerPage = newLimit
      this.loadAdminLogs()
    },

    pageChanged(page) {
      this.dataList.options.page = page
      this.loadAdminLogs()
    },

    async loadEventsCount() {
      try {
        const data = {
          type: 3,
          fieldType: 1,
          filters: [
            {
              type: 2,
              value: {
                start: this.dataset.rangeDate.startDate,
                end: this.dataset.rangeDate.endDate
              }
            }
          ]
        }

        const result = await axios.post('/api/dashboards/events-count', data)

        this.dataset.itemsCount.push(result.data.content)

        this.eventChart(result.data.content.details)

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000
        })
      }
    },

    async loadUsersCount() {
      try {
        const data = {
          type: 3,
          fieldType: 1,
          filters: [
            {
              type: 2,
              value: {
                start: this.dataset.rangeDate.startDate,
                end: this.dataset.rangeDate.endDate
              }
            }
          ]
        }

        const result = await axios.post('/api/dashboards/users-count', data)

        this.dataset.itemsCount.push(result.data.content)
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000
        })
      }
    },

    async loadUsersGroup() {
      try {
        const data = {
          type: 3,
          field: 'created_at',
          fieldLabel: 'Data de cadastro',
          fieldType: 1,
          filters: [
            {
              type: 2,
              value: {
                start: this.dataset.rangeDate.startDate,
                end: this.dataset.rangeDate.endDate
              }
            }
          ]
        }

        const result = await axios.post('/api/dashboards/users-group', data)

        const content = result.data.content

        this.dataset.charts.push(
          this.normalizeChartType('bar', content.items, content.title, content.description)
        )
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000
        })
      }
    },

    async loadTypeCountList() {
      try {
        const data = {
          type: 3,
          fieldType: 1,
          filters: [
            {
              type: 2,
              value: {
                start: this.dataset.rangeDate.startDate,
                end: this.dataset.rangeDate.endDate
              }
            }
          ]
        }

        const result = await axios.post('/api/dashboards/type-count', data)

        this.dataset.typesCount.push(result.data.content)

        this.typeCountCharts(result.data.content.details)

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000
        })
      }
    },

    async loadAdherencesCount() {
      try {
        const data = {
          type: 3,
          fieldType: 1,
          filters: [
            {
              type: 2,
              value: {
                start: this.dataset.rangeDate.startDate,
                end: this.dataset.rangeDate.endDate
              }
            }
          ]
        }

        const result = await axios.post('/api/dashboards/plan-adherence-count', data)

        this.dataset.itemsCount.push(result.data.content)

        this.planAdhereceChart(result.data.content.details)

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000
        })
      }
    },

    async loadReviewsEventsCount() {
      try {
        const data = {
          type: 3,
          fieldType: 1,
          filters: [
            {
              type: 2,
              value: {
                start: this.dataset.rangeDate.startDate,
                end: this.dataset.rangeDate.endDate
              }
            }
          ]
        }

        const result = await axios.post('/api/dashboards/credit-reviews-count', data)

        this.dataset.itemsCount.push(result.data.content)

        this.reviewEventChart(result.data.content.details)

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000
        })
      }
    },

    async loadEventsGroup() {
      try {
        const data = {
          type: 3,
          field: 'created_at',
          fieldLabel: 'Data de cadastro',
          fieldType: 1,
          filters: [
            {
              type: 2,
              value: {
                start: this.dataset.rangeDate.startDate,
                end: this.dataset.rangeDate.endDate
              }
            }
          ]
        }

        const result = await axios.post('/api/dashboards/events-group', data)

        const content = result.data.content

        this.dataset.charts.push(
          this.normalizeChartType('bar', content.items, content.title, content.description)
        )
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000
        })
      }
    },

    async loadResponsibleEventGroup(index = null) {
      try {
        let data = {
          type: 3,
          field: 'admins.id',
          fieldLabel: 'Responsável',
          fieldType: 2,
          filters: [
            {
              type: 5,
              value: {
                start: this.dataset.rangeDate.startDate,
                end: this.dataset.rangeDate.endDate
              }
            }
          ]
        }

        if (index || index == 0) {
          let currentRefField = this.dataset.charts[index].settings.listRefFields.find(
            (x) => x.value == this.dataset.charts[index].settings.refField
          )

          if (currentRefField) {
            data.field = this.dataset.charts[index].settings.refField
            data.filters = [
              {
                type: currentRefField.type,
                value: {
                  start: this.dataset.rangeDate.startDate,
                  end: this.dataset.rangeDate.endDate
                }
              }
            ]
          }
        }

        const result = await axios.post('/api/dashboards/responsible-event-group', data)

        const content = result.data.content

        const normalizedChart = this.normalizeChartType(
          'list',
          content.items,
          content.title,
          content.description,
          content.headers,
          { ...(content.additionalSettings || {}), _chartSource: 'responsible-event-group' }
        )

        if (index || index == 0) {
          this.$set(this.dataset.charts, index, normalizedChart)
        } else {
          this.dataset.charts.push(normalizedChart)
        }
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000
        })
      }
    },
 
    async loadResponsibleEventLog(index = null) {
      try {
         let data = {
          type: 3,
          field: 'admins.id',
          fieldLabel: 'Responsável',
          fieldType: 2,
          filters: [
            {
              type: 5,
              value: {
                start: this.dataset.rangeDate.startDate,
                end: this.dataset.rangeDate.endDate
              }
            }
          ]
        }

        if (index || index == 0) {
          const chart = this.dataset.charts[index]
          const currentRefField = chart.settings.listRefFields.find(
            x => x.value == chart.settings.refField
          )
          if (currentRefField) {
            data.field = chart.settings.refField
            data.filters = [
              {
                type: currentRefField.type,
                value: {
                  start: this.dataset.rangeDate.startDate,
                  end: this.dataset.rangeDate.endDate
                }
              }
            ]
          }
        }

        const result = await axios.post('/api/dashboards/responsible-event-log', data)

        const content = result.data.content

        const normalizedChart = this.normalizeChartType(
          'list',
          content.items,
          content.title,
          content.description,
          content.headers,
          { ...(content.additionalSettings || {}), _chartSource: 'responsible-event-log' }
        )

        if (index || index == 0) {
          this.$set(this.dataset.charts, index, normalizedChart)
        } else {
          this.dataset.charts.push(normalizedChart)
        }
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000
        })
      }
    },

    onSelectChange(index, value) {
      this.$nextTick(() => {
        const chart = this.dataset.charts[index]
        if (!chart || chart.type !== 'list') return

        if (chart.source === 'responsible-event-group') {
          this.loadResponsibleEventGroup(index)
        } else if (chart.source === 'responsible-event-log') {
          this.loadResponsibleEventLog(index)
        } else {
          this.loadResponsibleEventGroup(index)
        }
      })
    },

    normalizeChartType(type, items, title, description, headers = [], additionalSettings = {}) {
      switch (type) {
        case 'bar': {
          let categories = []
          let data = []

          categories = items.map((x) => x.ref)
          data = items.map((x) => x.value)

          return {
            settings: {
              chartOptions: {
                chart: {
                  type: 'bar',
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: false
                  }
                },
                xaxis: {
                  type: 'category',
                  categories
                }
              },
              series: [
                {
                  name: title,
                  data
                }
              ]
            },
            type,
            data,
            title,
            description
          }
        }
        case 'list': {
          for (let item of items) {
            if (this.$moment(item.ref, true).isValid()) {
              item.ref = this.$moment(item.ref).format('DD/MM/YYYY')
            }
          }

         const add = additionalSettings || {}
         const listRefFields = Array.isArray(add.listRefFields) ? add.listRefFields.map(f => ({ ...f })) : []
         const refField = (add.refField !== undefined && add.refField !== null) ? add.refField : null

          return {
            settings: {
              headers,
              items,
              listRefFields,
              refField
            },
            type,
            title,
            description,
            source: add._chartSource || null
          }
        }
      }
    },

    exportListToCSV(chart) {
      console.log('chart ', chart)
      const headers = chart.settings.headers
        .filter((x) => x.value != 'actions')
        .map((header) => header.text)

      const items = chart.settings.items
      let csvContent = headers.join(';') + '\n'

      items.forEach((item) => {
        const row = headers
          .map((header) => {
            const key = chart.settings.headers.find((h) => h.text === header).value

            if (key in item) return `"${item[key]}"`

            return ''
          })
          .join(';')
        csvContent += row + '\n'
      })

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', `${chart.title}.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    normalizedDateRange(dates) {
      return dates.map((x) => this.$moment(x).format('DD/MM/YYYY')).join(' - ')
    },

    normalizeRangeByType() {
      switch (this.dataset.filterSelected) {
        case 1:
          this.dataset.rangeDate.startDate = this.$moment().format('YYYY-MM-DD')
          this.dataset.rangeDate.endDate = this.$moment().format('YYYY-MM-DD')
          break
        case 2:
          this.dataset.rangeDate.startDate = this.$moment().subtract(1, 'd').format('YYYY-MM-DD')
          this.dataset.rangeDate.endDate = this.$moment().subtract(1, 'd').format('YYYY-MM-DD')
          break
        case 3:
          this.dataset.rangeDate.startDate = this.$moment()
            .subtract(7, 'd')
            .startOf('day')
            .format('YYYY-MM-DD')
          this.dataset.rangeDate.endDate = this.$moment().format('YYYY-MM-DD')
          break
        case 4:
          this.dataset.rangeDate.startDate = this.$moment().subtract(15, 'd').format('YYYY-MM-DD')
          this.dataset.rangeDate.endDate = this.$moment().format('YYYY-MM-DD')
          break
        case 5:
          this.dataset.rangeDate.startDate = this.$moment().subtract(30, 'd').format('YYYY-MM-DD')
          this.dataset.rangeDate.endDate = this.$moment().format('YYYY-MM-DD')
          break
        case 6:
          this.dataset.rangeDate.startDate = this.$moment().startOf('month').format('YYYY-MM-DD')
          this.dataset.rangeDate.endDate = this.$moment().endOf('month').format('YYYY-MM-DD')
          break
        case 7:
          this.dataset.rangeDate.startDate = this.$moment()
            .subtract(1, 'month')
            .startOf('month')
            .format('YYYY-MM-DD')
          this.dataset.rangeDate.endDate = this.$moment()
            .subtract(1, 'month')
            .endOf('month')
            .format('YYYY-MM-DD')
          break
        case 8:
          this.dataset.rangeDate.startDate = this.$moment()
            .subtract(3, 'month')
            .format('YYYY-MM-DD')
          this.dataset.rangeDate.endDate = this.$moment(new Date()).format('YYYY-MM-DD')
          break

        default:
          break
      }
    },

    changeFilter(type) {
      this.dataset.filterSelected = type

      if (type != 5) this.loadData()
    },

    async planAdhereceChart(content) {

      const statusLabelMap = this.dataset.eventStatus.reduce((acc, item) => {
        acc[item.id] = item.name
        return acc
      }, {})

      const totalByStatus = content && content.totalByStatus || []

      this.dataset.summaryChart.planAdhesion.series =
        totalByStatus.map(item => item.count)

      this.dataset.summaryChart.planAdhesion.options = {
        labels: totalByStatus.map(
          item => statusLabelMap[item.status] || `Status ${item.status}`
        ),
        colors: totalByStatus.map(
          item => this.dataset.statusColors[item.status] || '#90A4AE'
        ),
        legend: {
          position: 'bottom'
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            fontSize: '14px',
           
          },
          // formatter: function (value, opts) {
          //   return opts.w.globals.series[opts.seriesIndex]
          // }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '50%',
              labels: {
                show: true,

                name: {
                  show: true,
                  fontSize: '14px'
                },

                value: {
                  show: true,
                  fontSize: '18px',
                  fontWeight: 600,
                  formatter: val => val
                },

                total: {
                  show: true,
                  label: 'Total',
                  fontSize: '16px',
                  fontWeight: 600,
                  formatter: w => {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                  }
                }
              }
            }
          }
        }
      }
      
    },

    async typeCountCharts(content) {
      this.buildTypesDonutChart({
        rawData: content.planAdherencesByType || [],
        chartTarget: this.dataset.typesChart.planAdhesion
      })

      this.buildTypesDonutChart({
        rawData: content.objectionsByType || [],
        chartTarget: this.dataset.typesChart.creditReview
      })

      this.buildTypesDonutChart({
        rawData: content.eventsByType || [],
        chartTarget: this.dataset.typesChart.habDiv
      })
    },

    buildTypesDonutChart({ rawData, chartTarget }) {
      const typeLabelMap = this.dataset.typesCountList.reduce((acc, item) => {
        acc[item.id] = item.name
        return acc
      }, {})

      const mainTypes = [1, 3, 4]

      const grouped = {
        1: 0,
        3: 0,
        4: 0,
        outros: 0
      }

      rawData.forEach(item => {
        const type = item.type

        if (mainTypes.includes(type)) {
          grouped[type] += item.count
        } else {
          grouped.outros += item.count
        }
      })

      const finalData = []

      mainTypes.forEach(type => {
        if (grouped[type] > 0) {
          finalData.push({
            label: typeLabelMap[type],
            value: grouped[type],
            color: this.dataset.typesColors[type] || '#90A4AE'
          })
        }
      })

      if (grouped.outros > 0) {
        finalData.push({
          label: 'Outros',
          value: grouped.outros,
          color: '#B0BEC5'
        })
      }

      // aplica no gráfico recebido
      chartTarget.series = finalData.map(item => item.value)

      chartTarget.options = {
        labels: finalData.map(item => item.label),
        colors: finalData.map(item => item.color),
        legend: {
          position: 'bottom'
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            fontSize: '14px'
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '50%',
              labels: {
                show: true,

                name: {
                  show: true,
                  fontSize: '14px'
                },

                value: {
                  show: true,
                  fontSize: '18px',
                  fontWeight: 600,
                  formatter: val => val
                },

                total: {
                  show: true,
                  label: 'Total',
                  fontSize: '16px',
                  fontWeight: 600,
                  formatter: w => {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                  }
                }
              }
            }
          }
        },
        fill: {
          type: 'gradient',
        },
      }
    },

    async reviewEventChart(content) {
      const totalByStatus = content && content.totalByStatus || []

      const statusLabelMap = this.dataset.eventStatus.reduce((acc, item) => {
        acc[item.id] = item.name
        return acc
      }, {})

      const mainStatus = [0, 1, 2]

      const grouped = {
        0: 0,
        1: 0,
        2: 0,
        outros: 0
      }

      totalByStatus.forEach(item => {
        if (mainStatus.includes(item.status)) {
          grouped[item.status] += item.count
        } else {
          grouped.outros += item.count
        }
      })

      const finalData = []

      mainStatus.forEach(status => {
        if (grouped[status] > 0) {
          finalData.push({
            label: statusLabelMap[status],
            value: grouped[status],
            color: this.dataset.statusColors[status] || '#90A4AE'
          })
        }
      })

      if (grouped.outros > 0) {
        finalData.push({
          label: 'Outros',
          value: grouped.outros,
          color: '#B0BEC5'
        })
      }

      this.dataset.summaryChart.creditReview.series = finalData.map(item => item.value)

      this.dataset.summaryChart.creditReview.options = {
        labels: finalData.map(item => item.label),
        colors: finalData.map(item => item.color),
        legend: {
          position: 'bottom'
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            fontSize: '14px',
           
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '50%',
              labels: {
                show: true,

                name: {
                  show: true,
                  fontSize: '14px'
                },

                value: {
                  show: true,
                  fontSize: '18px',
                  fontWeight: 600,
                  formatter: val => val
                },

                total: {
                  show: true,
                  label: 'Total',
                  fontSize: '16px',
                  fontWeight: 600,
                  formatter: w => {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                  }
                }
              }
            }
          }
        }
      }
    },

    async eventChart(content) {

      const totalByStatus = content && content.totalByStatus || []

      const statusLabelMap = this.dataset.eventStatus.reduce((acc, item) => {
        acc[item.id] = item.name
        return acc
      }, {})

      const mainStatus = [0, 1, 2]

      const grouped = {
        0: 0,
        1: 0,
        2: 0,
        outros: 0
      }

      totalByStatus.forEach(item => {
        if (mainStatus.includes(item.status)) {
          grouped[item.status] += item.count
        } else {
          grouped.outros += item.count
        }
      })

      const finalData = []

      mainStatus.forEach(status => {
        if (grouped[status] > 0) {
          finalData.push({
            label: statusLabelMap[status],
            value: grouped[status],
            color: this.dataset.statusColors[status] || '#90A4AE'
          })
        }
      })

      if (grouped.outros > 0) {
        finalData.push({
          label: 'Outros',
          value: grouped.outros,
          color: '#B0BEC5'
        })
      }

      this.dataset.summaryChart.habDiv.series = finalData.map(item => item.value)

      this.dataset.summaryChart.habDiv.options = {
        labels: finalData.map(item => item.label),
        colors: finalData.map(item => item.color),
        legend: {
          position: 'bottom'
        },
        dataLabels: {
          enabled: true,
           style: {
            fontWeight: 'normal',
            fontSize: '14px',
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '50%',
              labels: {
                show: true,

                name: {
                  show: true,
                  fontSize: '14px'
                },

                value: {
                  show: true,
                  fontSize: '18px',
                  fontWeight: 600,
                  formatter: val => val
                },

                total: {
                  show: true,
                  label: 'Total',
                  fontSize: '16px',
                  fontWeight: 600,
                  formatter: w => {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                  }
                }
              }
            }
          }
        }
      }
    },
  }
}
</script>

<style lang="scss">
.home-title-page {
  color: var(--v-mediumBlack-base);
  font-family: "Plus Jakarta Sans", "Roboto", sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 38px;
}

.container-chart {
  max-width: 400px;
}

.home-card-details {
  background-color: var(--v-white-base) !important;
  height: 100%;
}

.home-card-details-title {
  text-transform: none !important;
  font-family: 'Poppins', sans-serif;
  color: var(--v-mediumBlack-base);
  font-size: 16px;
  font-weight: 500;
  //display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.home-global-card {
  background-color: var(--v-offWhite-base) !important;
}
</style>
